import {formatCurrency} from "@angular/common";

export class AnnualIncome {
  annualIncomeId: number;
  minValue: number;
  maxValue: number;
  displayValue: string;

  constructor(annualIncomeId?: number, minValue?: number, maxValue?: number, displayValue?: string) {
    this.annualIncomeId = annualIncomeId || 0;
    this.minValue = minValue || 0;
    this.maxValue = maxValue || 0;
    if (displayValue !== undefined && displayValue.trim().length > 0) {
      this.displayValue = displayValue;
    } else {
      this.displayValue = formatCurrency(this.minValue, 'en-us', '$') + " - " + formatCurrency(this.maxValue, 'en-us', '$') || "";
    }
  }
}
